// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3A-W6","topBottomGutter":"Layout_topBottomGutter__1CHn9"};